import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Container } from '@mui/material';

// Composant de formulaire pour envoyer un email via mailto
const FormComponent = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });

    // Gestion des changements dans les champs de formulaire
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Génération du lien mailto
    const handleSubmit = (e) => {
        e.preventDefault();
        const mailtoLink = `mailto:alexis.champion22@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Nom: ${formData.name}\nE-mail: ${formData.email}\n\nMessage: ${formData.message}`)}`;
        window.location.href = mailtoLink; // Redirection vers le lien mailto
    };

    return (
        <Container maxWidth="sm" sx={{ backgroundColor: '#141414', padding: '2rem', borderRadius: '10px', color: '#fff', marginTop: '2rem' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '2rem', textAlign: 'center' }}>
                Contactez-nous
            </Typography>

            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="Nom"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    margin="normal"
                    InputLabelProps={{ style: { color: '#aaa' } }}
                    sx={{
                        '& .MuiInputBase-root': { color: 'white' },
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555',
                        },
                        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#888',
                        },
                    }}
                />
                <TextField
                    fullWidth
                    label="E-mail"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    margin="normal"
                    InputLabelProps={{ style: { color: '#aaa' } }}
                    sx={{
                        '& .MuiInputBase-root': { color: 'white' },
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555',
                        },
                        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#888',
                        },
                    }}
                />
                <TextField
                    fullWidth
                    label="Sujet"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    margin="normal"
                    InputLabelProps={{ style: { color: '#aaa' } }}
                    sx={{
                        '& .MuiInputBase-root': { color: 'white' },
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555',
                        },
                        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#888',
                        },
                    }}
                />
                <TextField
                    fullWidth
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    required
                    margin="normal"
                    InputLabelProps={{ style: { color: '#aaa' } }}
                    sx={{
                        '& .MuiInputBase-root': { color: 'white' },
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555',
                        },
                        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#888',
                        },
                    }}
                />

                <Box sx={{ textAlign: 'center', marginTop: '1.5rem' }}>
                    <Button type="submit" variant="contained" color="primary" sx={{ width: '100%' }}>
                        Envoyer
                    </Button>
                </Box>
            </form>
        </Container>
    );
};

export default FormComponent;
